import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=08060e09"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports